import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import Footer from "../../components/Footer/Footer";
import routes from "../../router/AppRoutes";
import Router from "../../router/Router";
import Header from "../../views/Home/components/Header/Header";
import SubHeader from "./components/SubHeader/SubHeader";
import { LayoutBodyContainer, LayoutBodyDivider, LayoutContainer, LayoutFooterDivider } from "./styles/AppLayoutStyles";
import BackToTop from "../../components/BackToTop/BackToTop";
import DashboardSidebar from "../../views/MyDesk/components/DashboardSidebar";
import DashboardHeader from "../../views/MyDesk/components/DashboardHeader";
import { PageWrapper, MainPanel, ContentWrapper } from "../../views/MyDesk/styles/MyDeskStyles";
import LocalStorageService from "../../services/LocalStorageService";

const AppLayout = ({ children }) => {
    const location = useLocation();
    const { authenticated } = useSelector((state) => state.authReducer);
    const matchesWidth = useMediaQuery("(min-width:768px)");
    const [sidebarOpen, setSidebarOpen] = React.useState(matchesWidth);

    React.useEffect(() => {
        setSidebarOpen(matchesWidth);
    }, [matchesWidth]);

    // Check if the current route is under /app or is a service request form and requires authentication
    const isAppRoute = location.pathname.startsWith("/app");
    const isSolicitarRoute = location.pathname.startsWith("/solicitar-tramite");
    
    const currentRoute = routes.find(
        (r) => (r.layout ? r.layout + r.path : r.path) === location.pathname
    );
    const requiresLogin = currentRoute ? currentRoute.loginRequired : true;

    const isDashboardShell = (isAppRoute || isSolicitarRoute) && authenticated && requiresLogin;

    // Restablecer y mantener preferencias persistentes de Modo Oscuro e Idioma tras inicio de sesión o recarga
    React.useEffect(() => {
        const savedDarkMode = LocalStorageService.getItem('dark_mode');
        if (savedDarkMode === 'true' || savedDarkMode === '"true"') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }

        const savedLang = LocalStorageService.getItem('language');
        if (savedLang) {
            window.dispatchEvent(new CustomEvent('languageChange', { detail: savedLang }));
        }
    }, []);

    // Marca <body> mientras el shell administrativo está montado, para que las
    // reglas de tipografía en index.css (Inter para el panel admin) alcancen
    // también a los Dialog/Modal/Menu de MUI, que se renderizan vía portal
    // directamente en document.body y no dentro de PageWrapper.
    React.useEffect(() => {
        document.body.classList.toggle("admin-shell", isDashboardShell);
        return () => document.body.classList.remove("admin-shell");
    }, [isDashboardShell]);

    const getAppRoutes = () => {
        const appLayouts = [
            "/app",
            "/tramite",
            "/todos-los-tramites",
            "/solicitar-tramite",
            "/contacto",
            "/consultas-generales",
            "/politicas-de-privacidad",
            "/registro",
            "/base-legal",
            "/preguntas-frecuentes"
        ];
        return routes.filter((route) => appLayouts.includes(route.layout));
    };

    if (isDashboardShell) {
        return (
            <LayoutContainer style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <div style={{ flexShrink: 0, minHeight: "32px", backgroundColor: "#192873", position: "relative", zIndex: 1100, overflow: "visible" }}>
                    <mitur-topbar></mitur-topbar>
                </div>
                <PageWrapper style={{ flex: 1, display: "flex", width: "100%", overflow: "hidden", minHeight: "auto" }}>
                    {matchesWidth ? (
                        <DashboardSidebar collapsed={!sidebarOpen} />
                    ) : (
                        <Drawer
                            anchor="left"
                            open={sidebarOpen}
                            onClose={() => setSidebarOpen(false)}
                            PaperProps={{
                                sx: {
                                    width: '280px',
                                    bgcolor: '#FFFFFF',
                                    border: 'none',
                                    p: 0
                                }
                            }}
                        >
                            <DashboardSidebar collapsed={false} onCloseMobile={() => setSidebarOpen(false)} />
                        </Drawer>
                    )}
                    <MainPanel style={{ display: "flex", flexDirection: "column", height: "100%", minWidth: 0, overflow: "hidden" }}>
                        <DashboardHeader onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} sidebarOpen={sidebarOpen} />
                        <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column" }}>
                            <ContentWrapper style={{ flex: 1 }}>
                                <Router routes={getAppRoutes()} />
                            </ContentWrapper>
                        </div>
                    </MainPanel>
                </PageWrapper>
                <div style={{ width: "100%", flexShrink: 0, backgroundColor: "#FFFFFF", borderTop: "1px solid #C6C5D0", zIndex: 100 }}>
                    <mitur-footer variant="minimal" style={{ display: "block", width: "100%" }}></mitur-footer>
                </div>
            </LayoutContainer>
        );
    }

    return (
        <LayoutContainer>
            <div style={{ flexShrink: 0, minHeight: "32px", backgroundColor: "#192873", position: "relative", zIndex: 1100, overflow: "visible" }}>
                <mitur-topbar></mitur-topbar>
            </div>
            <Header />
            <SubHeader />
            <LayoutBodyDivider />
            <LayoutBodyContainer>
                {/* <ScrollToTopWithRouter> */}
                <Router routes={getAppRoutes()} />
                {/* </ScrollToTopWithRouter> */}
            </LayoutBodyContainer>
            <LayoutFooterDivider />
            <Footer />
            <BackToTop />
        </LayoutContainer>
    );
};

export default AppLayout;


